import {
  Identifiable,
  Planzone,
  ResourceDetailsConfiguration,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "@planzone/services";

function updateResourceDetailsConfiguration(httpClient: HttpClient) {
  return (
    { uuid }: Identifiable<Planzone>,
    configuration: ResourceDetailsConfiguration,
    nextConfiguration: ResourceDetailsConfiguration,
  ) =>
    httpClient.sendHttpRequest<void>({
      endpoint: `/planzones/${uuid}`,
      method: HttpMethods.PATCH,
      data: {
        data: {
          resourceDetailsConfiguration: JSON.stringify(nextConfiguration),
        },
      },
    });
}

export { updateResourceDetailsConfiguration };
